// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 8230) return "static/chunks/8230-ad883a72b1e5592a.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"5112":"eb3f6ca462890cdc","5308":"70c4f4402938c999","5601":"62aeb9e4459d52f4"}[chunkId] + ".js";
};